import React from 'react';
import { useTranslation } from 'react-i18next';

const MobileBlocker = () => {
    const { t } = useTranslation();

    return (
        <div className="mobile-blocker-overlay d-md-none">
            <style>{`
                .mobile-blocker-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background-color: #050505;
                    z-index: 99999;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 2rem;
                    text-align: center;
                    color: #fff;
                    font-family: 'Orbitron', sans-serif;
                }
                
                .blocker-icon {
                    font-size: 4rem;
                    color: var(--neon-red, #FF4500);
                    margin-bottom: 2rem;
                    animation: pulse-red 2s infinite;
                }

                .blocker-title {
                    font-size: 1.5rem;
                    letter-spacing: 2px;
                    margin-bottom: 1rem;
                    color: var(--neon-red, #FF4500);
                    text-transform: uppercase;
                }

                .blocker-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 0.9rem;
                    color: #888;
                    line-height: 1.6;
                    max-width: 300px;
                }

                @keyframes pulse-red {
                    0% { text-shadow: 0 0 0 rgba(255, 69, 0, 0); }
                    50% { text-shadow: 0 0 20px rgba(255, 69, 0, 0.5); }
                    100% { text-shadow: 0 0 0 rgba(255, 69, 0, 0); }
                }

                /* HIDE APP CONTENT ON MOBILE TO PREVENT SCROLL/INTERACTION */
                @media (max-width: 767px) {
                    .wrapper, .app-container, .top-navigation-bar, footer {
                        display: none !important;
                    }
                }
            `}</style>

            <div className="blocker-icon">
                <i className="bi bi-display"></i>
            </div>

            <h1 className="blocker-title">{t('DESKTOP ONLY')}</h1>

            <p className="blocker-text">
                {t('This terminal is optimized for large screens (Desktop/Tablet). Please access FilterMarket via a computer for the full analytical experience.')}
            </p>

            <div className="mt-5" style={{ opacity: 0.5, fontSize: '0.7rem', fontFamily: 'JetBrains Mono' }}>
                SYSTEM_ACCESS_DENIED_MOBILE
            </div>
        </div>
    );
};

export default MobileBlocker;
